module.exports = __webpack_public_path__ + "static/media/calendar.34e8bcd0.svg";